import { logger as baseLogger } from '@coder/logger';
export const logger = baseLogger.named('vscode');
